import styled, { css } from "styled-components";
import { Theme } from "interfaces/theme";
import { fonts } from "styles";

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 40px;
  line-height: 33px;
  letter-spacing: -3px;
  color: #0d3043;
  margin-bottom: 24px;
  text-align: center;
`;

export const Text = styled.article`
  width: 100%;
  max-width: 332px;
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #0d3043;
  margin-bottom: 40px;
  transition: 1s ease;

  p {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Credits = styled.div`
  width: 100%;
  border-top: 1px solid #0d3043;
  padding: 40px 16px 0 16px;
  display: flex;
  justify-content: space-between;
`;

export const Column = styled.div`
  width: 140px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  color: #0d3043;

  span {
    font-family: ${fonts.BentonSansRegular};
    font-size: 14px;
    line-height: 22px;
    display: block;
  }

  h6 {
    font-family: ${fonts.BentonSansBold};
    font-size: 15px;
    line-height: 22px;
  }
`;

interface IContainer {
  mode: Theme;
}

export const Container = styled.div<IContainer>`
  width: 100%;
  padding: 72px 45px 24px 45px;
  margin: 0 auto;
  display: none;

  ${({ mode }) =>
    mode === "dark" &&
    css`
      ${Title} {
        color: #fff;
      }
      ${Text} {
        color: #fff;
      }
      ${Credits} {
        border-color: #fff;
      }
      ${Column} {
        color: #fff;
      }
    `}

  @media screen and (max-width: 500px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media screen and (max-width: 375px) {
    padding: 72px 24px 24px 24px;
  }
`;
